<template>
  <v-flex data-qa="homeaccountdetails-flex-fyagmv">
    <Loader v-if="loaderEnabled" />
    <v-card
      class="mx-2"
      v-if="
        $appSettings.defaultConfigurations.landingPageConfig
          .enableTotalBalSection
      "
     data-qa="homeaccountdetails-card-x5m4i">
      <v-toolbar
        extended
        :extension-height="
          $appSettings.defaultConfigurations.landingPageConfig
            .gradientPanelHeight
        "
        dark
        :style="{ background: dashboardGradient }"
       data-qa="homeaccountdetails-toolbar-0cj34h">
        <v-row class="mt-8 pt-8 ml-4" dense data-qa="homeaccountdetails-row-yl7xu4">
          <v-flex lg7 xl7 data-qa="homeaccountdetails-flex-2r3s6">
            <v-row no-gutters data-qa="homeaccountdetails-row-7qnb1p">
              <inline-svg
                class="mt-3"
                :src="getNavigationIcon()"
                width="55"
                height="55"
                aria-label="Navigation Icon"
              ></inline-svg>
              <v-flex class="mx-4 my-2 mt-2" lg8 xl8 data-qa="homeaccountdetails-flex-fud7lq">
                <v-flex data-qa="homeaccountdetails-flex-9fluel">
                  <span class="font-weight-regular text-h6" data-qa="homeaccountdetails-span-7z3f9p">{{
                    $t("homeAccountDetails.totalBalance")
                  }}</span>
                </v-flex>
                <v-flex data-qa="homeaccountdetails-flex-3x2tuj">
                  <span class="font-weight-bold text-h4 pt-6" data-qa="homeaccountdetails-span-up2458">{{
                    $formatter.currency.format(chartDetails.myBalance)
                  }}</span>
                </v-flex>
              </v-flex>
            </v-row>
          </v-flex>
        </v-row>
        <v-icon
          v-if="$appSettings.defaultConfigurations.enableDesktopRefreshOption"
          class="mt-12"
          @click="refreshAccountList(true)"
          large
          dark
         data-qa="homeaccountdetails-icon-sfcfxs">
          mdi-refresh
        </v-icon>
      </v-toolbar>
    </v-card>
    <v-flex data-qa="homeaccountdetails-flex-qwv8a5"  v-if="!getOffersClass()" class="mt-4" />
    <v-flex
      :class="
        $appSettings.defaultConfigurations.landingPageConfig
          .enableTotalBalSection
          ? 'mt-n2'
          : 'mt-n6'
      "
     data-qa="homeaccountdetails-flex-zm24h8">
      <!-- Non-UK Market Savings -->
      <HomeCards
        v-if="!enableUkMarketSavingAccInDashboard && (enableSavingsSection || isNoticeSectionPermitted) && savingsAccount.accounts.length"
        :config="savingsAccount"
        class="mt-6"
      />
      <!-- Current Accounts -->
      <HomeCards
        v-if="enableCurrentSection && currentAccount.accounts.length"
        :config="currentAccount"
        class="mt-6"
      />
      <!-- START - UK Market Savings -->
            <!-- Regular Savings Accounts -->
      <v-divider v-if="enableUkMarketSavingAccInDashboard" class="my-8" data-qa="homeaccountdetails-divider-359cfs"></v-divider>
      <p class="font-weight-bold subtitle-2 pl-2" v-if="enableUkMarketSavingAccInDashboard" data-qa="homeaccountdetails-p-dbyq1">{{$t("common.savingsTitle")}} ({{savingsAccLength}})</p>
      <HomeCards
        v-if="enableUkMarketSavingAccInDashboard && enableSavingsSection && regularSavingsAccount.accounts.length"
        :config="regularSavingsAccount"
        class="mt-6"
      />
            <!-- Cash ISA Accounts -->
      <HomeCards
        v-if="enableUkMarketSavingAccInDashboard && enableSavingsSection && cashIsaAccount.accounts.length"
        :config="cashIsaAccount"
        :showOverallSubscriptionIsa="true"
        class="mt-6"
      />
            <!-- Deposit Account -->
      <HomeCards
        v-if="enableUkMarketSavingAccInDashboard && enableSavingsSection && depositAccount.accounts.length"
        :config="depositAccount"
        class="mt-6"
      />
      <!-- END - UK Market Savings -->
      <!-- Deposit Accounts -->
      <HomeCards
        v-if="!enableUkMarketSavingAccInDashboard && enableDepositSection && depositAccount.accounts.length"
        :config="depositAccount"
        class="mt-6"
      />
      <!-- Credit Card Accounts -->
      <v-divider v-if="enableCreditSection && creditCards.accounts.length && enableUkMarketSavingAccInDashboard" class="my-8" data-qa="homeaccountdetails-divider-2itesg"></v-divider>
      <HomeCards
        v-if="enableCreditSection && creditCards.accounts.length"
        :config="creditCards"
        class="mt-6"
      />
      <!-- Loan Accounts -->
      <v-divider v-if="enableLoanSection && loanAccount.accounts.length && enableUkMarketSavingAccInDashboard" class="my-8" data-qa="homeaccountdetails-divider-7hct0n"></v-divider>
      <HomeCards
        v-if="enableLoanSection && loanAccount.accounts.length"
        :config="loanAccount"
        :class="loanAccount.accounts.length ? 'mt-6' : ''"
      />
      <!-- Mortgage Accounts -->
      <!-- <v-divider v-if="enableMortgageSection && mortgageAccount.accounts.length && enableUkMarketSavingAccInDashboard" class="my-8" data-qa="homeaccountdetails-divider-62vyn"></v-divider> -->
      <HomeCards
        v-if="enableMortgageSection && mortgageAccount.accounts.length"
        :config="mortgageAccount"
        :class="mortgageAccount.accounts.length ? 'mt-6' : ''"
      />
      <!-- Offers -->
      <Offers
        v-if="enableOffersSection"
        :class="getOffersClass() ? 'mt-8 px-2' : 'mt-4 px-2'"
      />
    </v-flex>
  </v-flex>
</template>

<script>
import '@/styles/pages/home/homeAccountDetails.scss'
import store from '@/core/store'
import preload from '@/util/preload'
import event from '@/util/event'
import _ from 'lodash'
import { dashboardGradient } from '@/config/app/utility/themeUtility'
import Loader from '../../components/common/Loader.vue'

export default {
  name: 'HomeAccountDetails',
  components: {
    Loader,
    Offers: () => import('@/views/home/Offers.vue'),
    HomeCards: () => import('@/views/home/HomeCards.vue')
  },
  beforeCreate () {
    event.$off('refreshAccountList')
  },
  async created () {
    await this.checkAccountsPermission()
    await this.refreshAccountList()
    this.dashboardGradient = dashboardGradient
    event.$on('set_myAccounts', async () => {
      await this.getListOfAccounts()
    })
    event.$on('set_myLoanAccounts', async () => {
      await this.getListOfLoanAccounts()
    })
    event.$on('set_myMortgageAccounts', async () => {
      await this.getListOfLoanAccounts()
    })
    this.depositAccount.title = this.enableUkMarketSavingAccInDashboard ? this.$t('common.savingsSubTitle_3') : this.$t('common.depositTypeLabel')
  },
  data () {
    return {
      balance: '',
      loaderEnabled: false,
      viewClosedAccountsList: this.$appSettings.defaultConfigurations.viewClosedAccountsList,
      excludedAccountStatus: this.$appSettings.uiFieldsDisplayConfigurations.casaAccountListing.exclusionList,
      enableUkMarketSavingAccInDashboard:
        this.$appSettings.defaultConfigurations.landingPageConfig
          .enableUkMarketSavingAccInDashboard,
      enableSavingsSection:
        this.$appSettings.defaultConfigurations.landingPageConfig
          .enableSavingsSection,
      enableCurrentSection:
        this.$appSettings.defaultConfigurations.landingPageConfig
          .enableCurrentSection,
      enableDepositSection:
        this.$appSettings.defaultConfigurations.landingPageConfig
          .enableDepositSection,
      enableOffersSection:
        this.$appSettings.defaultConfigurations.landingPageConfig
          .enableOffersSection,
      enableLoanSection:
        this.$appSettings.defaultConfigurations.landingPageConfig
          .enableLoanSection,
      enableMortgageSection:
        this.$appSettings.defaultConfigurations.landingPageConfig
          .enableMortgageSection,
      enableNoticeSection:
        this.$appSettings.defaultConfigurations.landingPageConfig
          .enableNoticeSection,
      isNoticeSectionPermitted: false,
      enableCreditSection:
        this.$appSettings.defaultConfigurations.landingPageConfig
          .enableCreditSection && this.$appSettings.defaultConfigurations.cards.enableCreditCard,
      savingsAccount: {
        title: this.$t('common.savingsTypeLabel'),
        noticeAccountsTitle: '',
        cardLabels: true,
        openNewACCard: this.$appSettings.defaultConfigurations.enableOpenNewAccountOption,
        accounts: []
      },
      regularSavingsAccount: {
        title: this.$t('common.savingsSubTitle_1'),
        noticeAccountsTitle: '',
        cardLabels: true,
        openNewACCard: this.$appSettings.defaultConfigurations.enableOpenNewAccountOption,
        accounts: []
      },
      cashIsaAccount: {
        title: this.$t('common.savingsSubTitle_2'),
        noticeAccountsTitle: '',
        cardLabels: true,
        openNewACCard: this.$appSettings.defaultConfigurations.enableOpenNewAccountOption,
        accounts: []
      },
      ukMarketSavingsAccount: {
        title: this.$t('common.savingsTypeLabel'),
        subSection: this.$appSettings.defaultConfigurations.landingPageConfig.ukMarketSavingsGrouping
      },
      currentAccount: {
        title: this.$t('common.currentTypeLabel'),
        cardLabels: true,
        openNewACCard: this.$appSettings.defaultConfigurations.enableOpenNewAccountOption,
        accounts: []
      },
      depositAccount: {
        title: this.$t('common.depositTypeLabel'),
        cardLabels: true,
        openNewACCard: this.$appSettings.defaultConfigurations.enableOpenNewAccountOption,
        accounts: []
      },
      noticeAccount: {
        title: this.$t('common.noticeTypeLabel'),
        cardLabels: true,
        openNewACCard: this.$appSettings.defaultConfigurations.enableOpenNewAccountOption,
        accounts: []
      },
      creditCards: {
        title: this.$t('common.creditTypeLabel'),
        cardLabels: true,
        openNewACCard: this.$appSettings.defaultConfigurations.enableOpenNewAccountOption,
        accounts: []
      },
      chartDetails: {
        myBalance: 0,
        series: []
      },
      chartOptions: {
        chart: {
          type: 'donut'
        },
        dataLabels: {
          enabled: false
        },
        labels: [],
        legend: {
          position: 'right',
          labels: {
            colors: '',
            useSeriesColors: []
          }
        }
      },
      loanAccount: {
        title: this.$t('common.loanLabel'),
        cardLabels: true,
        openNewACCard: false,
        accounts: []
      },
      mortgageAccount: {
        title: this.$t('common.mortgageAgreementLabel'),
        cardLabels: true,
        openNewACCard: false,
        accounts: []
      },
      allAccounts: [],
      dashboardGradient: {},
      savingsAccLength: 0,
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Savings_1')
    },
    async checkAccountsPermission () {
      if (this.isSmeLogin && this.enableRoleBasedAccess) {
        // Set the dashboard sections as per the SME user permissions
        const enabledAccountType = store.getters['profileStore/profileData']?.enabledAccountType

        const sections = {
          saving: 'enableSavingsSection',
          current: 'enableCurrentSection',
          deposit: 'enableDepositSection',
          loan: 'enableLoanSection',
          mortgage: 'enableMortgageSection',
          creditCard: 'enableCreditSection',
          debitCard: 'enableDebitCardSection'
        }

        Object.entries(sections).forEach(async ([key, section]) => {
          if (this[section]) {
            this[section] = await enabledAccountType?.[key]
          }
        })
        this.isNoticeSectionPermitted = await enabledAccountType?.notice
      } else {
        this.isNoticeSectionPermitted = true
      }
    },
    async refreshAccountList (fromRefreshBtn = false) {
      this.chartDetails.myBalance = 0
      if (fromRefreshBtn) {
        await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
        await preload.getListOfLoanAccounts(
          JSON.parse(sessionStorage.getItem('username'))
        )
      }
      await this.getListOfAccounts()
      await this.getListOfLoanAccounts()
    },
    async getListOfAccounts () {
      await this.checkAccountsPermission()
      const data = await store.getters['userStore/userData'].myAccounts
      this.chartDetails.myBalance = 0
      if (data) {
        this.allAccounts = []
        // Savings AC List
        this.savingsAccount.accounts = data.savingAccounts
          ? data.savingAccounts.accountList
          : []
        if (this.savingsAccount.accounts.length) {
          this.savingsAccount.accounts = _.filter(
            this.savingsAccount.accounts,
            (account) => {
              if (this.viewClosedAccountsList && this.viewClosedAccountsList.length &&
                this.viewClosedAccountsList.includes(account.accountType) && account.accountStatus === 'CLOSED') {
                return account
              } else return !(this.excludedAccountStatus.includes(account.accountStatus))
            }
          )
          
          if (!this.isNoticeSectionPermitted) {
            this.savingsAccount.accounts = await this.savingsAccount?.accounts?.filter((account) => {
						  return account?.accountType !== 'NACC'
					  })
          }
          if (!this.enableSavingsSection) {
            this.savingsAccount.accounts = await this.savingsAccount?.accounts?.filter((account) => {
						  return account?.accountType !== 'SVGS'
					  })
          }
        }

        // Current AC List
        this.currentAccount.accounts = data.currentAccounts
          ? data.currentAccounts.accountList
          : []
        if (this.currentAccount.accounts.length) {
          this.currentAccount.accounts = _.filter(
            this.currentAccount.accounts,
            (account) => {
              if (this.viewClosedAccountsList && this.viewClosedAccountsList.length &&
                this.viewClosedAccountsList.includes(account.accountType) && account.accountStatus === 'CLOSED') {
                return account
              } else return !(this.excludedAccountStatus.includes(account.accountStatus))
            }
          )
        }
        // Notice AC List
        this.noticeAccount.accounts = (data.noticeAccounts && this.enableNoticeSection && this.isNoticeSectionPermitted)
          ? data.noticeAccounts.accountList
          : []
        if (this.noticeAccount.accounts.length) {
          this.savingsAccount.noticeAccountsTitle = this.$t(
            'common.savingsNoticeTypeLabel'
          )
        }
        // Deposit AC List
        this.depositAccount.accounts = data.deposits
          ? data.deposits.accountList
          : []
        if (this.depositAccount.accounts.length) {
          this.depositAccount.accounts = _.filter(
            this.depositAccount.accounts,
            (account) => {
              if (!this.$appSettings.uiFieldsDisplayConfigurations.TDAccountListing.exclusionList.includes(
                account.status
              )) {
                return account
              }
            }
          )
        }
        // Credit Cards AC List
        this.creditCards.accounts = data.creditCards
          ? data.creditCards.accountList
          : []
        if (this.creditCards.accounts.length) {
          this.creditCards.accounts = _.filter(
            this.creditCards.accounts,
            (account) => {
              if (!this.$appSettings.uiFieldsDisplayConfigurations.TDAccountListing.exclusionList.includes(
                account.status
              )) {
                return account
              }
            }
          )
        }
        if (this.enableUkMarketSavingAccInDashboard) {
          this.allAccounts = [...this.savingsAccount.accounts, ...this.currentAccount.accounts, ...this.noticeAccount.accounts, ...this.depositAccount.accounts]
          const filteredAcc = {}
          this.ukMarketSavingsAccount.subSection.forEach((section) => {
            section.accType.forEach((type) => {
              Object.assign(
                filteredAcc,
                {
                  ...filteredAcc,
                  [type]: {
                    ...filteredAcc[type],
                    type,
                    label: section.label,
                    accounts: this.allAccounts.filter((acc) => acc.accountType === type)
                  }
                }
              )
            })
          })
          let newArr = []
          newArr = Object.values(filteredAcc)
          const result = _.groupBy(newArr, ({ label }) => label)
          this.regularSavingsAccount.accounts = []
          for (let index = 0; index < result['common.savingsSubTitle_1'].length; index++) {
            for (let innerIndex = 0; innerIndex < result['common.savingsSubTitle_1'][index].accounts.length; innerIndex++) {
              this.regularSavingsAccount.accounts.push(result['common.savingsSubTitle_1'][index].accounts[innerIndex])
            }
          }
          this.cashIsaAccount.accounts = []
          for (let index = 0; index < result['common.savingsSubTitle_2'].length; index++) {
            for (let innerIndex = 0; innerIndex < result['common.savingsSubTitle_2'][index].accounts.length; innerIndex++) {
              this.cashIsaAccount.accounts.push(result['common.savingsSubTitle_2'][index].accounts[innerIndex])
            }
          }
          const filteredSvgsAcc = []
          this.savingsAccount.accounts.forEach((svgsAcc) => {
            if (this.ukMarketSavingsAccount.subSection[0].accType.includes(svgsAcc.accountType)) {
              filteredSvgsAcc.push(svgsAcc)
            }
          })
          this.regularSavingsAccount.accounts = [...filteredSvgsAcc]
          this.savingsAccLength = 0
          this.savingsAccLength = this.regularSavingsAccount?.accounts?.length + this.cashIsaAccount?.accounts?.length + this.depositAccount?.accounts?.length
          this.$store.dispatch('userStore/setUserData', { cashIsaAccount: this.cashIsaAccount.accounts })
        }
        for (const i in data) {
          switch (data[i].label) {
            case 'currentAccounts':
              this.chartOptions.labels.push('Current')
              this.chartDetails.series.push(data[i].totalCurrentBalance)
              this.chartDetails.myBalance += data[i].totalCurrentBalance
              break
            case 'savingAccounts':
              this.chartOptions.labels.push('Savings')
              this.chartDetails.series.push(data[i].totalSavingBalance)
              this.chartDetails.myBalance += data[i].totalSavingBalance
              break
            case 'depositAccounts':
              this.chartOptions.labels.push('Deposits')
              this.chartDetails.series.push(data[i].totalDepositBalance)
              this.chartDetails.myBalance += data[i].totalDepositBalance
              break
            default:
          }
        }
      }
    },
    async getListOfLoanAccounts () {
      this.loaderEnabled = true
      const loanAccounts = await store.getters['userStore/userData']
        .loanAccounts
      const mortgageAccounts = await store.getters['userStore/userData']
        .mortgageAccounts
      if (loanAccounts && loanAccounts.length) {
        this.loanAccount.accounts = loanAccounts
      }
      if (loanAccounts && mortgageAccounts && mortgageAccounts.length) {
        this.mortgageAccount.accounts = mortgageAccounts
      }
      this.loaderEnabled = false
    },
    sorted (actions) {
      return _.sortBy(actions)
    },
    getOffersClass () {
      if (
        (this.savingsAccount.accounts && this.savingsAccount.accounts.length) ||
        (this.currentAccount.accounts && this.currentAccount.accounts.length) ||
        (this.noticeAccount.accounts &&
          this.noticeAccount.accounts.length &&
          this.enableNoticeSection && this.isNoticeSectionPermitted) ||
        (this.depositAccount.accounts && this.depositAccount.accounts.length) ||
        (this.loanAccount.accounts && this.loanAccount.accounts.length)
      ) { return true }
      return false
    }
  }
}
</script>
